import { adminApi, api } from './axios';

export function fetcher({ queryKey }: any) {
  return api.get(queryKey[0]).then(({ data }) => data);
}

export function adminFetcher({ queryKey }: any) {
  return adminApi.get(queryKey[0]).then(({ data }) => data);
}
